function updateWishlistHeart(button) {

  const icon = button.querySelector(".favorite-icon");

  if (!icon) return;


  const variantId = Number(
    button.dataset.variantId
  );


  const isFavorite =
    App.wishlist.exists(variantId);


  button.classList.toggle(
    "is-favorite",
    isFavorite
  );


  icon.src = isFavorite
    ? icon.dataset.filled
    : icon.dataset.empty;

}



function bindWishlistButtons() {

  document
    .querySelectorAll(".favorite-btn")
    .forEach((button) => {


      updateWishlistHeart(button);


      button.addEventListener("click", () => {


        const product = {
          productId: Number(
            button.dataset.productId
          ),

          variantId: Number(
            button.dataset.variantId
          ),

          handle:
            button.dataset.productHandle
        };


        App.wishlist.toggle(product);


        updateWishlistHeart(button);

      });


    });

}


window.App = window.App || {};

window.App.wishlistUI = {
  update: updateWishlistHeart,
  bind: bindWishlistButtons
};